import { useFormikContext } from 'formik'
import {
  AlertPosition,
  CellProps,
  ContentWrapper,
  hasEditableTableCells,
  SubmitButtonWithAlert
} from '../../../../../components'
import { useAlert } from '../../../../../contexts'
import { EmploymentData, EmploymentsTableProps } from '../types'

interface EmploymentsSubmitButtonProps {
  employmentKeysAndColumns: CellProps<EmploymentData>[]
}

export const EmploymentsSubmitButton = ({
  employmentKeysAndColumns
}: EmploymentsSubmitButtonProps) => {
  const { values } = useFormikContext<EmploymentsTableProps>()

  const { alertType } = useAlert()

  const hasEditableRows = hasEditableTableCells(
    values.tyosuhteet,
    employmentKeysAndColumns
  )

  return (
    <ContentWrapper
      showContent={hasEditableRows || alertType?.severity !== undefined}
    >
      <SubmitButtonWithAlert
        alertProps={{
          alertPosition: AlertPosition.LEFT,
          sx: { fontWeight: 600 }
        }}
        justifyContent="flex-end"
      />
    </ContentWrapper>
  )
}
